export type WalletErrorType = 'insufficientBalance' | 'noSecondaryMethod';

export class WalletError extends Error {
  type: WalletErrorType;
  constructor(errType: WalletErrorType) {
    super(errType);
    this.type = errType;
  }
}
